/**
 俄语
 */
const lang = {
	lang: { //语言切换
		langlist: [{
			type: "Chinese",
			name: "китайский язык ",
			langimg: "../assets/zg.png"
		},
		{
			type: "English",
			name: " английский",
			langimg: "../assets/zg.png"
		},
		{
			type: "Traditional",
			name: "китайский стиль ",
			langimg: "../assets/zg.png"
		},
		{
			type: "Japanese",
			name: "японская письменность ",
			langimg: "../assets/zg.png"
		},
		{
			type: "Vietnamese",
			name: "вьетнамский язык ",
			langimg: "../assets/zg.png"
		},
		{
			type: "Malay",
			name: "малайский язык ",
			langimg: "../assets/zg.png"
		},
		{
			type: "Hindi",
			name: " индийский язык ",
			langimg: "../assets/zg.png"
		},
		{
			type: "Thai",
			name: "Тайский язык ",
			langimg: "../assets/zg.png"
		},
		{
			type: "Russian",
			name: "русский язык ",
			langimg: "../assets/zg.png"
		},
		{
			type: "Indonesian",
			name: "индонезийский язык ",
			langimg: "../assets/zg.png"
		}
		],
		langtype: "Russian",
		langimg: "../assets/zg.png"
	},

	tabbar: { //底部
		index: "Первая страница ",
		activity: "деятельность ",
		to_promote: "распространение ",
		help: "помочь ",
		my: "мой "
	},
	// 提示
	prompt: {
		verification: " Ошибка проверки кода ",
		account: " номер счета 8 - 20 ",
		password: "пароль больше, чем 6 - битный набор цифр + букв или символов ",
		two: "двукратное несоответствие паролей ",
		successful: "регистрация прошла успешно",
		loginsuccessful: "регистрация прошла успешно ",
		null: " код счёта не может быть пустым ",
		Binding: "связать успешно ",
		address: " Заполните, пожалуйста, адрес. ",
		Please_choose: "Выберите пункт и введите сумму",
		Bet_type: "Выберите тип Примечания",
		success: " отметить успешно ",
		complete_password: "Введите полный пароль",
		copy_success: " Скопировано на срез ",
		copy_fail: " Ошибка копирования ",
		Set_success: " Настройка выполнена ",
		Set_password: "Укажите 6 - значный код, который не может содержать ‘буква, соответствие, пробел’ ",
		update_success: "изменение завершено",
		input_number: " Введите количество",
		addressvalue: "Выберите адрес бумажника"
	},
	head: { //头部
		luckyhash: "хашимитское поручительство ",
		address: " адрес бумажника ",
		history: "История ввода ",
		help: " помочь ",
		lotteryRecord: "рекорд открытия премии ",
		notice: " Список объявлений ",
		question: "Общие вопросы ",
		performance: "награда ",
		add_address: " Добавить бумажник ",
		asset: "код актива",
		balance: "сальдо ",
		exchangeRecord: "обмен",
		forrecord: "акт обмена ",
		language: "Настройки языка",
		update_assets_password: "Изменить пароль актива",
		update_login_password: "Изменить пароль входа",

		myteam: "Моя команда",
		recharge: "остаток ",
		setting: "Настройки",
		transactiondetails: "запись доставки",
		transfer: "перевод комиссионных ",
		user: "персональный центр",
		userInfo: "Личные сведения",
		withdrawal: "представлять ",
		commission: "выставление комиссионных",
		withdrawalRecord: " запись передачи ",
		top_up: "запись с закладкой"
	},
	withdrawalRecord: {
		Select_month: "Выберите месяц",
		afterPrice: "сальдо ",

	},
	withdrawal: {
		withdrawalrecord: " запись передачи ",
		commission: "Денежные активы",
		number: "количество подлежащих передаче ",
		withdrawal_number: "количество извлечения ",
		money_address: "адрес бумажника",
		addressvalue: "Выберите адрес получателя ",
		poundage: "комиссионные ",
		immediately: "немедленная подача",
		Warm_prompt: "теплые советы: заполните правильный адрес бумажника, иначе невозможно получить деньги, получить адрес бумажника после заполнения не может быть изменен, если необходимо изменить",
		input_password: 'Введите код актива ',
		betting: " вносить ",

	},
	userInfo: {
		Head_portrait: "личный портрет",
		account: "номер счета",
		Choose_picture: "выбор заголовка",
		cancel: "отмена ",
		determine: "определение "
	},
	user: {
		wallet_account: " счёт бумажника ",
		balance: "сальдо ",
		top_up: "наполнение ",
		withdrawal: "представлять",
		my_wallet: "мой кошелек",
		add_wallet: "Добавить бумажник",
		look: "Просмотреть запись",
		look_all: "смотреть больше",
		Pack_up: "убирать ",
		For_record: "акт обмена",
		bettingRecord: "спецификация сделок",
		reward: "Поощрение",
		goCustomerLink: "онлайн - сервис",
		Commission_account: "комиссионный счет",
		transfer: "переход",
		number: "вводимые данные",
		transactiondetails: "проверять спецификацию",
		day: "сегодня ",
		day_winning: "выигрыш сегодня",
		my_team: "Моя команда",
		about_we: "о нас",
		center: "центр обслуживания",
		setting: "Настройки",
	},
	transfer: {
		money: "остаток комиссионных",
		account_balance: "сальдо счета",
		number: "количество подлежащих передаче",
		select: "Выберите",
		Immediately_transfer: "немедленная передача",
		password: "Введите код актива",
		betting: "вносить",

	},
	transactiondetails: {
		type: "тип ",
		input_type: "Выберите тип",
		date: "дата ",
		select_date: "Выберите дату",
		select: "запрос",
		bettingmoney: "сумма внесения",
		winning_amount: "сумма выигрыша",
		time: "время ",
		not: "Нет данных",
		B1: 'счастье-счастливый размер',
		B2: 'счастье-счастливая комбинация',
		B3: 'счастье-Счастливый дракон',
		B4: 'счастье-счастливый дом',
		B5: 'счастье-счастливая цифра',
		A1: 'Хаши (город)-везучий гоночный',
		A2: 'Хаши (город)-катер удачи',
		A3: 'Хаши (город)-бег на счастье',
		A4: 'Хаши (город)-счастливый размер',
		A5: 'Хаши (город)-счастливая комбинация',
		A6: 'Хаши (город)-Счастливый дракон',
		A7: 'Хаши (город)-счастливый дом',
		A8: 'Хаши (город)-счастливая цифра',
		options: [{
			value: "счастье -двусторонний",
			label: "B1",
		},
		{
			value: "счастье -комбинация ",
			label: "B2",
		},
		{
			value: "счастье -дракон и тигр",
			label: "B3",
		},
		{
			value: "счастье -все товары",
			label: "B4",
		},
		{
			value: "счастье -бесстрашный",
			label: "B5",
		},
		],
	},
	setting: {
		updatepwd: "Изменить пароль входа",
		assets_pwd: "код актива",
		not: "не установлено",
		yes: "Настройки",
		language: "Настройки языка",
		exit: "выход",

	},
	recharge: {
		recharge_code: "запись с закладкой",
		Chain_type: "тип цепи",
		address: " адрес наполнения",
		copy_address: "Скопировать адрес",
		remind: "оперативный напоминание",
		content: "Содержание содержание содержание"
	},
	myteam: {
		select: "запрос ",
		time: "дата ",
		money: " дневное вознаграждение",
		people: "непосредственная численность",
		team: "команда ",
		jryj: 'Сегодняшние результаты',
		jrsy: 'Заработок сегодня',
		ljsy: 'совокупный доход',
		friendsCategoryList: ['друг первого класса', 'второстепенный друг', 'друг третьего уровня', 'друг 4 класса', 'друг 5 уровня'],
	},
	login: {
		order_password: "старый пароль",
		input_ordpwd: "Введите старый пароль",
		new_pwd: "новый пароль",
		number: "Укажите размер 6 - 16 букв и цифр",
		six_pwd: "Введите 6 - битный цифровой код",
		confirmPassword: "подтвердить пароль",
		confirm: "подтверждение",
	},
	forrecord: {
		spending: "расход по обмену",
	},
	exchangeRecord: {
		exchangeRecord: "обмен ",
		record: "запись ",
		For_spending: "расход по обмену",
		money: "конвертируемая сумма",
		exchange_number: " разменный количество",
		number: "количество",
		market_price: "рыночная цена ",
		Miners_fee: "шахтный сбор",
		input_money: "Введите сумму обмена",
		Get_the_amount: "получить сумму",
		Can_be: "доступная сумма",
		address: "адрес бумажника",
		Immediatelychange: "немедленная конверсия",
		Warm_prompt: "подсказка",
		details: " подробности, подробности, подробности "
	},
	balance: {
		balance_of: "сальдо ",
		data: "дата ",
		dataPickerRange: "Выберите ",
		select: "запрос ",
		to: 'to'
	},
	asset: {
		password: "Укажите 6 - значный код, который не может содержать ‘буква, соответствие, пробел’ ",
		confirm: "подтверждение ",
	},
	add_address: {
		money_address: "Введите адрес бумажника（TRC20）",
		save: "Сохранить "
	},
	spread: {
		cumulative: "Ваше кумулятивное приглашение",
		people: "человек ",
		make: "получить ",
		Continue_to: " продолжать свои усилия",
		url: "поделиться ссылками",
		Friends_registered: "регистрация друзей ",
		money: "связать бумажник",
		Friends_deal: "дружеская сделка",
		copy_url: "Копировать приглашение по ссылке",
		my_group: "Моя команда",
		look: "просмотреть результаты работы",
		directCount: "непосредственная численность",
		group: "Численность команды",
		Commission_withdrawal: "выставление комиссионных",
		historyAward: "история получила комиссионные",
		yesterdayAward: "вчерашние комиссионные",
		currentAward: "действующий комиссионный",
		todayAward: "работа сегодня",
		my_invite: "код приглашения",
		copy_invite: "Копировать пригласительный код",
		top_title: "мой начальник",
		update: " Невозможно изменить привязку начальника",
		nikname: "Введите верхние псевдонимы, требующие привязки",
		binding: "привязывать",
		Commission_ratio: "пропорция комиссионных",

		level: "уровень",
		ratio: "Доля возвращающихся работников (ставки) ",
		Directly_under: " субординация",
		first: " Статья",
		levelone: "ступень ",

	},
	performance: {
		datatime: "дата ",
		pick: "Выберите ",
		select: "запрос ",
		total: "общий результат сегодня",
		performance: "производственная спецификация",
		directCount: "собственная численность игроков",
		todayTotalPerformByDirect: "сегодня непосредственно деятельность игроков",
		other: "другие игроки",
		todayTotalPerformByOther: "другие игроки",
		Commission_withdrawal: "выставление комиссионных",
		historyAward: "история получила комиссионные",
		yesterdayAward: "вчерашние комиссионные",
		currentAward: "действующий комиссионный",
		todayAward: "работа сегодня",
		Commission_ratio: "пропорция комиссионных",
		level: "уровень",
		ratio: "Доля возвращающихся работников (ставки) ",
		Directly_under: " субординация",
		first: " Статья",
		levelone: "ступень ",
	},
	lotteryRecord: { //开奖记录
		block: "блок ",
		highly: "высота блока",
		results_of: "результат",

	},
	help: {
		DAPP: "DAPP шаг игры ",
		a: "Копирование адреса игры DAPP для USDT - TRC20 ",
		b: "открыть этот сайт в браузере цепочки блоков бумажника (TRX Network) можно сразу же сделать ставку DAPP, без копирования",
		Focus_on: "Пожалуйста, обратите внимание на обновление нашей домашней страницы, чтобы получить последний адрес сделки.",
		login: "Введите хаотическое значение блока запросов в сети",
		hash: "у вас есть доступ к хашему значению блоков в сети",
		you: "Вы можете быть в сети",
		login_website: "вход в сеть",
		query: "ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ðµ",
		look: "Нажмите для просмотра учебника ",
		congratulations: "рад вас",
		winning: "если выиграешь, система вернется к вам через минуту",
		address: "если выиграете, система в течение 1 минуты вернёт премию в ваш адрес перечисления.",
		number: "купля USDT и TRX на бирже цифровых денег",
		skip: "если в бумажнике уже есть USDT и TRX, пропустите этот шаг",
		Digital_currency: "купить на бирже цифровых денег USDT и TRX, а затем перевести USDT и TRX в ваш [центральный кошелек], вы можете использовать бумажник, зарегистрированный на сайте центрального бумажника ：",
		platform: "платформа ",
		url: "сайт ",
		tutorial: "курс ",
		vpn: "Подсказка: если невозможно открыть Telegram, используйте Бог VPN",
		vpnurl: "сайт VPN",
		whirlwind: "веб - сайт циклонного ускорителя",
		can_login: "Можно войти",
		why: "почемуxxxx",
		most_fair: "самый справедливый",
		play: "ни пинка, ни оборачивания, ни помех",
		Publicly_available: "хаотическое значение блока генерируется случайно, результат унифицирован, не может быть изменен, открыто задокументирован",
		security: " Наиболее безопасный ",
		no_money: "Как видно из средств эксплуатации, не стоит бояться возврата денег на приз",
		Cannot: "Информация о всех переводах очевидна и не может быть ложной.",
		Visi_convenient: "самый быстрый",
		Without_registration: "без регистрации, без предварительной закладки, без обращения за получением денег",
		questions: "Общие вопросы",
		one: "Что такое【хаотическое значение блока 】（Block Hash）",
		dna: "хешированное значение блоков - это ДНК одного сегмента данных, и все хаотические значения каждого блока являются единственными, случайными и неразрешимыми. ",
		lookintroduce: " Нажмите, чтобы просмотреть презентацию байду Хаши 。",
		what: "Какая блочная цепь ",
		Block_chain: " цепочка блоков по существу является общей базой данных, в которой хранятся данные или информация.  Она обладает такими характеристиками, как неотвратимость фальсификации, полное оставление следов, Ретроактивность, транспарентность, коллективное обслуживание и т.д. ",
		wallet: "центральный бумажник?  перейти к центру бумажника?  Почему центральный кошелек не может получить доступ к переводу? ",
		example: " например, ваш собственный адрес бумажника является A, вы можете перевести Адрес E в 10USDT, но вы используете значение гашиша операции, чтобы получить доступ только к какому - либо получателю услуг в произвольном порядке на какой - то счет адрес B (или C или D и т.д.  Аналогичным образом, е не может узнать, были ли эти 10 USDT вывезены из вашей страны, так как E может видеть только адрес счёта B и переводит его на 10 USDT.  Вот почему центральный кошелек не может просматривать информацию о реальном переводе на обуви блока. ",
		why_winning: "Почему я выигрываю подряд или не выигрываю? ",
		First: "первый раз подряд подряд многократно выигрывать - это маловероятное событие ",
		small: "определение маловероятного события ",
		second: " Во - вторых, выигрыш, а не выигрыш, является случайным событием, и частота случайных событий будет стабилизироваться.  В случае непериодия вероятность появления вещи равна для всех, и в этом случае все равны.  В то же время случайное событие подчиняется закону больших чисел (при испытании без изменений повторяется несколько раз, частота случайного события приближается к его закону больших вероятностей), а в случае увеличения частоты перевода вероятность выигрыша и невыдачи будет равнена - стабильному значению.  Поэтому, пожалуйста, продолжайте переводить деньги, по мере увеличения частоты перечисления повышается общая вероятность выигрыша. ",
		whydelay: " Зачем откладывать на счёт ",
		Click_to_view: "Щёлкните на поле для просмотра скорости блоков： 《 ваше доверие, медлительность》",
		six: " Параметры типа USDT для обращения денежных знаков с ключом?  что я должен выбрать?",
		global: " в мире много известных связей ",
		click_look: "Обзор глобальных сетей Kig ",
		how: " при пересчете валют Укажите адрес или тип неверной валюты. что делать?  можно ли вернуться?",
		For_instance: "  например, вы должны указать тип USD TRC20, но вы выбрали другой тип USD - OMNI или USDERC20, и тогда появится ситуация, когда деньги будут потеряны, которую невозможно вернуть. ",
		How_to_force: " что делать, если повернуть не ту монету? ",
		Other_problems: " Прочие вопросы ",
		callwe: "если у вас есть вопросы, обращайтесь к нам",
		immediately: "немедленная подача ",
		company: " Информация о компании ",
		link: " дружеские связи ",
		register: "регистрировать цифровые деньги",
		Already_have: "если у вас уже есть бумажник, пропустите этот шаг",
		download: "загрузить и зарегистрировать цифровую монету в центре бумажника",
		com_title: "монеты в бумажнике"
	},
	register: { //登录注册
		login_tips: "Введите пароль для входа",
		address: "Введите адрес бумажника",
		confirm: "подтвердить пароль",
		confirmupdate: "подтверждать изменение",
		toRegister: "зарегистрироваться",
		agreement: "как войти",
		user: "Протокол пользователя",
		policy: "политика уединения",
		welcome: "Добро пожаловать",
		login: "регистрация на ваш счёт",
		forget: "забыть пароль",
		nowLogin: "вход ",
		nologin: "временно не входить",
		new: "Создать новый счёт",
		login: "как ваш регистрационный номер",
		account: "номер счета 8 - 20",
		password: "пароль больше, чем 6 - битный набор цифр + букв или символов",
		confirm_password: "подтвердить пароль",
		inviteCode: "Введите код приглашения (заполните)",
		verificationCode: "Введите код проверки",
		toRegister: "регистрация",
		noaccount: "Нет номера счета",
		toLogin: "войти"
	},
	address: {
		warmprompt: "теплые советы: заполните правильный адрес бумажника, иначе невозможно получить деньги, получить адрес бумажника после заполнения не может быть изменен, если необходимо изменить ",
		tips: "Пожалуйста, свяжите хотя бы один адрес бумажника, чтобы забыть пароль ",
		TRC20: "чтобы избежать ошибок при вводе, нажмите кнопку вставить （TRC20）",
		toBind: " немедленная привязка ",
		noBind: "временно не связать",
	},
	luckyhash: { //幸运哈希
		walletName: 'связать бумажник',
		exchange: "обмен",
		reward: "награда ",
		Customerservice: "принимать гостей",
		instructions: "Примечание ",
		luckyhash: "счастье ",
		entertainment: "Хаши (город)",
		Doublesided: "двусторонний ",
		odds: "вероятность ",
		immediately: "немедленная подача",
		combination: "комбинация ",
		LongHuge: "дракон и тигр",
		baccarat: "все товары",
		gallbladder: "бесстрашный ",
		Hashracingcar: "гоночная машина",
		Hashspeedboat: "катер с гашишем",
		Hashracing: "хашимитский конь",
		bothsides: "двуличный",
		problem: "Общие вопросы",
		all: "смотреть больше",
		friend: "партнёр"
	},
	history: {
		block: "блок",
		type: "тип ",
		big: "большой ",
		highly: "высота блока",
		results_of: "результат"
	},
	entertainment: {
		lastBlock: "предыдущий блок",
		resultValue: "результат премии",
		currentblock: "текущий блок",
		nextBlock: "открытый блок",
		toLotteryRecord: "рекорд открытия премии",
		block: "блок",
		money1: "Общая сумма",
		type: "тип ",
		all: "смотреть больше",
		both_sides: "двуличный",
		big: "большой ",
		small: "маленький",
		single: "лист ",
		double: "пара ",
		champion: "чемпион ",
		yajun: 'второе место',
		champion_one_size: "код чемпиона",
		crown: "субординация",
		andbig: "и большой",
		andsmall: " и меньше",
		andsingle: "мирный",
		anddouble: "пара ",
		championtwo: "две стороны чемпиона",
		combination: "комбинация ",
		forlarge: "расписка ",
		smallsingle: "квитанция ",
		large_double: "большая пара",
		small_double: "пара",
		Long_Huge: "дракон и тигр",
		dragon: "дракон",
		tiger: "тигр ",
		us: "подходить ",
		baccarat: "все товары",
		zhuang: "лавка ",
		idle: "б ",
		gallbladder: "бесстрашный ",
		Atotalof: "всего ",
		note: "Примечания ",
		Check_the_details: "смотреть подробности",
		money: "остаток бумажника",
		pause: "машинное обогащение",
		reset: "сбросить",
		inputmoney: "Введите сумму",
		submit: "представление ",
		password: "Введите пароль операции",
		betting: "вносить",
		determine: "определение ",
	},
	details: {
		block: "блок ",
		money: "Общая сумма",
		type: "тип ",
		resultValue: " результат премии ",
		all: " смотреть больше ",
		address: "адрес подачи",
		toLotteryRecord: "рекорд открытия премии ",
		money: "бумажник",
		copy: "Скопировать адрес",
		ts: "не использовать адрес биржи, иначе невозможно получить обратно приз",
		USDT: "Пожалуйста, наберите поле волны USDT / TRX（Trc20）",
		Betting_amount: "сумма внесения",
		inputmoney: "Введите сумму",
		confirm: "подтверждение ",
		cancel: "отмена ",
	},
	data: {
		noData: 'Пока нет данных',
		deleteSuc: 'Удалено успешно',
		iscon: 'подтверждение доставки?',
		fenpan: 'в запечатанном конверте, в течение которого нельзя делать примечание',
		erweima: 'сохранить двухмерный код'
	},
	announcement: {
		title: 'Последнее объявление',
		close: 'закрытие',
	},
	phone: {
		title: 'номер телефона',
		phone: 'номер телефона',
		input: 'Введите номер мобильного телефона',
		code: 'код проверки',
		inputcode: "Введите код проверки",
		getCode: 'получение кода проверки',
		details: 'Заполните, пожалуйста, номер телефона.',
		success: 'успешно отправлен код проверки',
		bsuccess: 'связать успешно',
		jiaoyi: 'Укажите пароль операции',
		caozuo: "Операция прошла успешно",
		touxiang: "Выберите изображение головы",
		buzu: 'дефицит',
		tuiguan: 'центр распространения',
		qubie: 'Щёлкните для просмотра различий между блочными цепочками',
		yhm: 'Введите имя пользователя',
		mm: 'Введите ваш пароль',
		xqgg: 'пойти погулять',
		llwm: 'связаться с нами',
		lj: 'Сначала соедините бумажник',
		dk: 'Открыть в бумажнике APP',
		qd: 'Мы с нетерпением ждем вашего присоединения',
		yjmx: 'комиссионная спецификация'
	},
	vip: {
		jl: "награда",
		xrjl: 'новые награды',
		ckgz: 'правила просмотра',
		zcsj: 'регистрационный платеж',
		qbsj: 'адрес привязки телефона и бумажника',
		dlq: 'ожидающий получения',
		qwc: 'перейти к завершению',
		ylq: 'получаться',
		tgrw: 'задача распространения',
		rwjl: 'вознаграждение за выполнение задач',
		yq: 'приглашать',
		ghy: 'хороший друг',
		lqcg: 'получить успех',
		bz: "Please enter the recharge currency",
		je: 'Please enter the recharge amount',
		xyb: 'next step',
		czpz: 'Please upload the recharge voucher',
		zzhx: 'Please enter transfer hash',
		ljtj: 'Submit now'

	}

}
export default lang



// WEBPACK FOOTER //
// ./src/i18n/language/Russian.js